<template>
  <div class="page-launching">
    <div class="time-container">
      <div class="content-container">
        <div>
          <span class="text">{{leftTime.s}}</span>
          <span class="text"
                style="font-size: 0.5rem">{{leftTime.ms}}</span>
          <span class="unit">秒</span>
        </div>
        <div class="circle rotate-div"></div>
      </div>
    </div>
    <div class="tip">
      <div class="content">
        <div class="tip-title">启动中，请勿拔枪</div>
        <div class="tip-sub-title">启动过程中拔枪会造成订单异常</div>
      </div>
      <img src="../../../assets/img/ic_launching_tip.png">
    </div>
    <div class="launching-tips">
      <div class="launching-tips-flex">
        <p>充电过程，人车分离！</p>
        <p>起火勿救，迅速远离！</p>
      </div>
      <div class="launching-tips-img">
        <img src="../../../assets/image/launching-tips.png" alt="">
      </div>
    </div>
    <div class="btn-box"
         v-if="btnShow">
      <div class="btn-error-text">受网络影响，充电启动已超时</div>
      <!-- <pi-button type="primary" block @click="goBack">继续等待</pi-button> -->
      <pi-button block
                 @click="endCharging"
                 :loading="endLoading">结束充电</pi-button>
    </div>
  </div>
</template>

<script>
import { startCharging, startTimeout } from "../../../common/api";

export default {
  name: "change-page",
  components: {},
  data() {
    return {
      pauseEndTime: "",
      leftTime: { s: null, ms: null },
      // accountPkId: null,
      // gunNumber: null,
      // serialNumber: null,
      orderNo: null,
      timer: null,
      timeout: null,
      endLoading: false,
      btnShow: false,
      isCountDown: false, // 倒计时还是顺时
    };
  },
  props: {
    propOrderNo: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.$common.bodyAddBg();

    this.orderNo = this.propOrderNo == '' ? this.$route.query.orderNo : this.propOrderNo;
    this.startCharging();
    this.pollUpdate();
  },
  methods: {
    startCharging() {
      startCharging({
        orderNo: this.orderNo,
      },false)
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            if(data.data[0].flag == 1){
              clearTimeout(this.timeout);
              clearInterval(this.timer);
              this.$dialog
                .alert({
                  title: "启动充电失败",
                  message: "请重新插拔枪并且重新扫码!",
                  confirmButtonText: "确认",
                  confirmButtonColor: "#999999",
                  closeOnPopstate: true,
                })
                .then(() => {
                  this.goBack();
                });
              return;
            }
            if ( data.data[0].orderStatus === 1 ) {
              //枪口状态和订单状态同时变为充电中时，跳转到充电中界面
              this.$router.replace({
                name: "charge/charging",
                query: {
                  // accountPkId: this.accountPkId,
                  // gunNumber: this.gunNumber,
                  // serialNumber: this.serialNumber,
                  orderNo: this.orderNo,
                  replace: true
                },
              });
            } else {
              let orderData = data.data[0];
              if (orderData.orderStatus == 4) {
                this.$common.checkOrderIsAbnormal(
                  this.$router,
                  orderData.orderStatus
                );
              } else {
                if (this.pauseEndTime == "") {
                  if (this.isCountDown) {
                    let beginTime = orderData.beginTime + 180 * 1000;
                    this.pauseEndTime = new Date(beginTime);
                  } else {
                    let beginTime = orderData.beginTime;
                    this.pauseEndTime = new Date(beginTime);
                  }
                  let currTime = orderData.currTime;
                  this.nowTime = currTime;
                  this.countDown();
                }
              }
            }
          } else {
            //订单异常
            throw new Error();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    endCharging() {
      this.endLoading = true;
      startTimeout({ orderNo: this.orderNo })
        .then((ret) => {
          if (ret.status === this.$config.ajaxStatus) {
            this.$toast("结束成功");
            this.$router.go(-1);
          }
          this.endLoading = false;
        })
        .catch(() => {
          this.endLoading = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    pollUpdate() {
      this.timer = setInterval(() => {
        this.refresh();
      }, this.$config.pullTimeDistance);
    },
    refresh() {
      this.startCharging();
    },

    countDown() {
      var nowTime = new Date(this.nowTime);
      var leftTime;
      var ms;
      if (this.isCountDown) {
        leftTime = parseInt(
          (this.pauseEndTime.getTime() - nowTime.getTime()) / 1000
        );
        ms = parseInt((this.pauseEndTime.getTime() - nowTime.getTime()) % 1000);
      } else {
        leftTime = parseInt(
          (nowTime.getTime() - this.pauseEndTime.getTime()) / 1000
        );
        ms = parseInt((nowTime.getTime() - this.pauseEndTime.getTime()) % 1000);
      }
      // var leftTime = parseInt(
      //   (this.pauseEndTime.getTime() - nowTime.getTime()) / 1000
      // );
      // var ms = parseInt(
      //   (this.pauseEndTime.getTime() - nowTime.getTime()) % 1000
      // );
      // var leftTime = parseInt(
      //   (nowTime.getTime() - this.pauseEndTime.getTime()) / 1000
      // );
      // var ms = parseInt(
      //   (nowTime.getTime() - this.pauseEndTime.getTime()) % 1000
      // );

      var m = parseInt((leftTime / 60) % 60);
      var s = parseInt(leftTime % 60);

      this.leftTime.s = `${m * 60 + s}.`;
      this.leftTime.ms = `${parseInt(ms / 100)}`;
      if (
        (this.isCountDown && leftTime < 70) ||
        (!this.isCountDown && leftTime > 110)
      ) {
        this.btnShow = true;
      }

      if (
        (this.isCountDown && leftTime <= 0 && ms <= 0) ||
        (!this.isCountDown && leftTime >= 180)
      ) {
        this.$dialog
          .alert({
            title: "启动失败",
            message: "请重新插拔枪并且重新扫码!",
            confirmButtonText: "确认",
            confirmButtonColor: "#999999",
            closeOnPopstate: true,
          })
          .then(() => {
            this.endCharging();
          })
          .catch(() => {});
        return;
      }
      if (this.isCountDown) {
        this.nowTime = this.nowTime - 100;
      } else {
        this.nowTime = this.nowTime + 100;
      }
      this.timeout = setTimeout(this.countDown, 100);
    },
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
  },
  beforeDestroy() {
    console.log("launching beforeDestroy");
    clearInterval(this.timer);
    clearTimeout(this.timeout);
    this.$common.removeBodyBg();
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/old/var.less";
.circle {
  width: 4.45rem;
  height: 4.45rem;
  position: absolute;
  left: -0.05rem;
  top: -0.05rem;
  background-image: url("../../../assets/img/circle-orange.png");
  background-size: 100% 100%;
}
.page-launching {
  padding: 0.2rem;
  .time-container {
    width: 100%;
    height: 4.85rem;
    background: url("../../../assets/img/bg_launching_top.png");
    background-size: 100% 100%;
    .flex-center();
    .content-container {
      .flex-center();
      position: relative;
      color: white;
      width: 4.35rem;
      height: 4.35rem;
      border: dashed 1px white;
      border-radius: 50%;
      .text {
        font-size: 1rem;
      }
      .unit {
        font-size: 0.3rem;
        padding-left: 0.2rem;
      }
    }
  }
  .tip {
    background-color: #fff;
    border-radius: 0.1rem;
    .flex-align-center();
    padding: 0.2rem;
    .content {
      flex: 1;
      .tip-title {
        font-size: 0.46rem;
        font-weight: 600;
        color: #666666;
      }
      .tip-sub-title {
        font-size: 0.3rem;
        color: #999999;
        margin-top: 0.1rem;
      }
    }
    img {
      width: 1.6rem;
      height: 1.6rem;
    }
  }
  .btn-box {
    margin-top: 0.5rem;
    padding: 0.2rem 0.3rem;
    .btn-error-text {
      text-align: center;
      margin-bottom: 0.2rem;
      font-size: 0.24rem;
      color: #999;
    }
    .pi-button {
      margin-bottom: 0.2rem;
    }
  }
  .launching-tips{
    margin-top: 0.2rem;
    background-color: #fff;
    border-radius: 0.12rem;
    display: flex;
    padding: 0.2rem 0.35rem;
    .launching-tips-flex{
      flex: 1;
      font-size: 0.46rem;
      line-height: 0.65rem;
      color: #666;
      padding: 0.15rem 0;
    }
    .launching-tips-img{
      width: 1.6rem;
      height: 1.6rem;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
